import { getServerlessImageHandlerUrl } from '~/components/Image/helpers'

import { getCloudfrontUrl } from '../Metadata.util'

import { Element, BlockType } from './Schema.types'

function handleElement<T extends Element>(element: T): string {
  if (element._type === 'latex') {
    return `$$${element.body}$$`
  }
  if ((element._type === BlockType.MATH_VAULT_AWS_IMAGE || BlockType.BOOTCAMP_AWS_IMAGE) && element.srcKey) {
    const srcKey = element.srcKey
    const url = getCloudfrontUrl({ srcKey })
    return `<img src="${url}" alt="${element.alt}" />`
  }
  return element.text ?? ''
}

export function toPlainText<T extends { _type?: string; children?: Element[]; content?: Element[] } | Element>(
  blocks: T[],
): string {
  return blocks
    .map((block) => {
      if (block._type === BlockType.DIGITAL_TEXT && block.content) {
        return toPlainText(block.content)
      }
      if ('children' in block && block.children) return block.children.map(handleElement).join('')
      if (block) return handleElement(block as Element)
      return ''
    })
    .join(' ')
}

export function countWords(str: string): number {
  return str.trim().split(/\s+/).length
}

export const logoUrl = getServerlessImageHandlerUrl({ key: 'logos/house-of-math.svg', edits: { toFormat: 'png' } })

// Single source of truth for Organization markup, used as author/publisher across schemas.
// sameAs mirrors the social links in the site footer — keep the two in sync.
export const organizationSchema = {
  '@type': 'Organization',
  '@id': 'https://www.houseofmath.com/#organization',
  name: 'House of Math',
  url: 'https://www.houseofmath.com',
  logo: {
    '@type': 'ImageObject',
    url: logoUrl,
  },
  sameAs: [
    'https://www.linkedin.com/company/house-of-math/',
    'https://www.facebook.com/houseofmath.as',
    'https://www.instagram.com/houseofmath/',
  ],
}
